<template>
  <div class="category-slider" :class="platform" data-t="category-slider">
    <div class="header">
      <StSkeletonLoader
        bg-color="var(--background-primary)"
        height="20px"
        width="150px"
        :shimmer-opacity="0.25"
      />
    </div>
    <div class="content">
      <component
        :is="gameCardSkeletonComponent"
        v-for="card in isMobile ? 7 : 5"
        :key="card"
        class="card-game"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const { platform, isMobile } = usePlatform()

const gameCardSkeletonComponent = computed(() =>
  isMobile.value
    ? defineAsyncComponent(() => import('../GameCard/MGameCardSkeleton.vue'))
    : defineAsyncComponent(() => import('../GameCard/GameCardSkeleton.vue')),
)
</script>

<style scoped>
.category-slider {
  .header {
    display: flex;
    grid-template-columns: auto;
    justify-content: space-between;

    min-height: 28px;
    margin-bottom: var(--spacing-100);
  }

  .card-game {
    width: 216px;
  }

  .content {
    display: flex;
    gap: var(--spacing-150);
    align-items: flex-start;
  }

  &.mobile {
    padding: 0 var(--spacing-200);

    .header {
      margin-bottom: var(--spacing-150);
    }

    .content {
      overflow: hidden;
      display: grid;
      grid-auto-columns: 140px;
      grid-auto-flow: column;
      grid-template-rows: repeat(2, 130px);
      gap: var(--spacing-200) var(--spacing-125);
    }

    .card-game {
      width: 140px;
    }
  }
}
</style>
